module.exports = __webpack_public_path__ + "static/media/vopa_logo_white.a5690e67.png";